
import React, { useState } from 'react';

type Props = {
    ClosePopup?: Function;
    OnApprove?: Function;
    approveBtnTitle?: string;
    messageTitle?: string;
    messageContent: string;
};

const ErrorFieldsAlert = (props: Props) => {

    const closePopup = (status?: string) => {
        if (props.ClosePopup) {
            props.ClosePopup(status);
        }
    }

    const approve = () => {
        if (props.OnApprove) {
            props.OnApprove();
        }
    }

    return (<div
            onClick={()=>closePopup()}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                // width:'30%',
                // height: 200,
                // backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000
            }}>
            <div
                onClick={(e) => e.stopPropagation()} // Prevent click events from reaching the overlay
                style={{
                    width: 300,
                    height: 200,
                    backgroundColor: '#fff',
                    padding: '20px',
                    borderRadius: '5px',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                    textAlign: 'center'
                }}>
                {/* create messege for success from server */}

                <>
                    <h2>{props.messageTitle}</h2>
                    <p style={{ color: 'red', fontSize: 20 }}> {props.messageContent} </p>
                    
                    <button onClick={() => closePopup() } style={{
                        margin: '10px',
                        padding: '10px 20px',
                        backgroundColor: '#007BFF',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}>

סגור                   
 </button>
                </>
            </div>
        </div>

    );
}

export default ErrorFieldsAlert;